import * as React from "react";
import { Typography } from "antd";
import RelativeWorkingInCourtGrid from "./RelativeWorkingInCourtGrid";
import AdditionalIncomeGrid from "./AdditionalIncomeGrid";
import NonPaidActivityGrid from "./NonPaidActivityGrid";
import GiftAndDonationGrid from "./GiftAndDonationGrid";
import DebtObligationGrid from "./DebtObligationGrid";
import { IReport8ApplicantPresentationModel } from "../../../../presenter/report/model/Report8ApplicantPresentationModel";

const Report8Preview = ({
  translate,
  data,
  title,
  subtitle
}: {
  translate?: any;
  data: IReport8ApplicantPresentationModel[];
  title?: string;
  subtitle?: string;
}) => {
  return (
    <div>
      <Typography.Title style={{ fontSize: 14 }}>
        {`${translate("reports.params.reporting_period")}: ${title}`}
      </Typography.Title>
      <Typography.Title style={{ fontSize: 12, marginBottom: 20 }}>
        {`${translate("reports.report")}: ${subtitle}`}
      </Typography.Title>
      {data &&
        data.map(item => {
          return (
            <div>
              <Typography.Title style={{ fontSize: 14 }}>
                {`${translate("report8.document_template.applicant")}: ${
                  item.fullName
                }`}
              </Typography.Title>
              <RelativeWorkingInCourtGrid
                translate={translate}
                data={item.relativesWorkingInCourt}
              />
              <AdditionalIncomeGrid
                translate={translate}
                data={item.additionalIncome}
              />
              <NonPaidActivityGrid
                translate={translate}
                data={item.nonPaidActivities}
              />
              <GiftAndDonationGrid
                translate={translate}
                data={item.giftsAndDonations}
              />
              <DebtObligationGrid
                translate={translate}
                data={item.debtObligations}
              />
            </div>
          );
        })}
    </div>
  );
};

export default Report8Preview;
